/**
 * THE PROMPT BOX'S UPPER-LEFT GROUP — ONE component for every prompt box (room · Build · the Rules planner), so they
 * look and behave exactly the same (owner 2026-10-22): Attach · </> (code snippet) · Bold · Italic · Normal · bulleted
 * list · numbered list (MODES.md §3c). Attach / </> run their handler when given, else they're greyed with why (never
 * hidden). The format buttons keep the field's selection (mousedown) and call ``onFormat(action)`` — pair with
 * ``useMarkdownField``. ``testId`` keeps each surface's ids (``room-composer``, ``build-composer``, …).
 */
import React from 'react';
import { Paperclip, Bold, Italic, RemoveFormatting, List, ListOrdered } from 'lucide-react';
import { DECK_ICON_BUTTON } from './CommandDeck.jsx';

export const FORMAT_ACTIONS = [['bold', Bold, 'Bold (⌘B)'], ['italic', Italic, 'Italic (⌘I)'],
  ['normal', RemoveFormatting, 'Normal text — clear formatting'], ['bullet', List, 'Bulleted list (⌘⇧8)'],
  ['number', ListOrdered, 'Numbered list (⌘⇧7)']];

export default function DeckLeftGroup({
  testId, onFormat, formatDisabled = false,
  onAttach = null, attachDisabled = false, attachSoon = 'Attaching files here — coming soon',
  onSnippet = null, snippetDisabled = false, snippetSoon = 'Code snippets here — coming soon',
  children = null,
}) {
  return (
    <>
      <button type="button" data-testid={`${testId}-attach`} onClick={onAttach || undefined}
        disabled={!onAttach || attachDisabled} aria-label="Attach files"
        title={onAttach ? 'Attach files' : attachSoon} className={DECK_ICON_BUTTON}>
        <Paperclip className="h-4 w-4" aria-hidden />
      </button>
      {/* CODE SNIPPET (CONTEXT-DOCS §P4) — Slack's `</>`: paste code → a file on the message. Shaded so it reads as
          "code", not another attach. */}
      <button type="button" data-testid={`${testId}-snippet`} onClick={onSnippet || undefined}
        disabled={!onSnippet || snippetDisabled} aria-label="Add a code snippet"
        title={onSnippet ? "Code snippet — paste code (.py, .json, .yaml …); it's shared as a file" : snippetSoon}
        className={`${DECK_ICON_BUTTON} bg-slate-200/70 font-mono text-[11px] font-semibold text-slate-700`}>
        &lt;/&gt;
      </button>
      {/* TEXT FORMAT (MODES.md §3c) — after `</>`; mousedown keeps the field's selection */}
      <span data-testid={`${testId}-format`} className="ml-0.5 inline-flex items-center border-l border-gray-200 pl-0.5">
        {FORMAT_ACTIONS.map(([k, Icon, t]) => (
          <button key={k} type="button" data-testid={`${testId}-format-${k}`} aria-label={t} title={t}
            disabled={formatDisabled} onMouseDown={(e) => e.preventDefault()} onClick={() => onFormat?.(k)}
            className={DECK_ICON_BUTTON}>
            <Icon className="h-3.5 w-3.5" aria-hidden />
          </button>
        ))}
      </span>
      {children}
    </>
  );
}
